import { render } from "./VisaCard.vue?vue&type=template&id=55170d54&scoped=true"
import script from "./VisaCard.vue?vue&type=script&lang=js"
export * from "./VisaCard.vue?vue&type=script&lang=js"

import "./VisaCard.vue?vue&type=style&index=0&id=55170d54&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55170d54"]])

export default __exports__